import { render, staticRenderFns } from "./VdmListView.vue?vue&type=template&id=a90194c8&scoped=true"
import script from "./VdmListView.vue?vue&type=script&lang=js"
export * from "./VdmListView.vue?vue&type=script&lang=js"
import style0 from "./VdmListView.vue?vue&type=style&index=0&id=a90194c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90194c8",
  null
  
)

export default component.exports